var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRightCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM14.0303 6.96967C13.7374 6.67678 13.2626 6.67678 12.9697 6.96967C12.6768 7.26256 12.6768 7.73744 12.9697 8.03033L16.1893 11.25H6C5.58579 11.25 5.25 11.5858 5.25 12C5.25 12.4142 5.58579 12.75 6 12.75H16.1893L12.9697 15.9697C12.6768 16.2626 12.6768 16.7374 12.9697 17.0303C13.2626 17.3232 13.7374 17.3232 14.0303 17.0303L18.5303 12.5303C18.8232 12.2374 18.8232 11.7626 18.5303 11.4697L14.0303 6.96967Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowRightCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-right-circle.51ad6fd7eca1d367356a04b139c8bc24.svg";